import React, { Component } from 'react';
import classnames from 'classnames';

const symbol = ['+', '-', '×', '÷', '=', '>', '<'];

function getDom(item, index, answerMap) {
    let dom = null;
    switch (item.type) {
        case 'text':
            // 文本
            dom = <span key={index}>{item.text}</span>;
            break;
        case 'blank':
            // 空（四声）
            const classname = classnames({
                'fillin-express': true,
                'circle': answerMap && symbol.indexOf(answerMap[item.id].split('|')[0]) > -1
            });
            dom = <span
                className={classname}
                data-id={item.id}
                key={index} />;
            break;
        case 'latex':
            // 数学公式
            dom = <span className='mathquill-embedded-latex' key={index}>{item.content}</span>;
            break;
        case 'P':
            // 换行
            dom = <span style={{ marginTop: 14, display: 'block' }} key={index} />;
            break;
        case 'delivery_equation':
            // 脱式题
            dom = <span key={index}>{item.content}</span>;
            break;
        case 'audio':
            // 音频
            dom = <audio src={item.src} key={index}></audio>;
            break;
        case 'img':
            // 图片
            dom = <img
                className={item.size}
                src={item.src}
                alt='加载失败'
                key={index} />;
            break;
        case 'fill_img':
            // 图片挖空的图片
            dom = <span style={{ position: 'relative', display: 'inline-block' }} key={index}>
                <img className={item.size} src={item.src} alt='加载失败' />
                {
                    item.blanklist.map(blank =>
                        <span
                            className='fill_image_blank'
                            data-size={blank.size}
                            style={{
                                left: `${blank.x_pos}%`,
                                top: `${blank.y_pos}%`
                            }}
                            key={blank.id}></span>
                    )
                }
            </span>;
            break;
        default:
            break;
    }
    return dom;
};

class Stem extends Component {
    render() {
        const { stem, answerMap } = this.props;

        return (
            <div>
                {
                    stem.map((para, i) =>
                        <p className={para.style} key={i}>
                            {
                                para.children.map((child, index) =>
                                    getDom(child, index, answerMap)
                                )
                            }
                        </p>
                    )
                }
            </div>
        )
    }
}

export default Stem;
export { getDom };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/NormalStem.js